import React, { useEffect } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { Field, reduxForm, FieldArray } from 'redux-form'
import { useSelector } from 'react-redux'
import { FormButtons, validations, renderers } from '../../components'
import { getListTypes } from '../../state/lists'
const renderListItems = ({ fields, meta: { error, submitFailed } }) => {
  if (fields.length === 0) {
    fields.push({})
  }
  return (
    <ReactBootstrap.ListGroup>
      {fields.map((member, index) => (
        <ReactBootstrap.ListGroupItem key={index}>
          <Field
            name={`${member}.value`}
            type="text"
            validate={[validations.required]}
            component={renderers.renderField}
            label="Value"
          />
          <Field
            name={`${member}.code`}
            type="text"
            validate={[validations.required]}
            component={renderers.renderField}
            label="Code"
          />

          <Field
            name={`${member}.description`}
            type="text"
            validate={[validations.required]}
            component={renderers.renderField}
            label="Description"
          />

          <ReactBootstrap.Button
            style={{ float: 'right' }}
            variant="outline-dark"
            size="sm"
            title="Remove Member"
            onClick={() => fields.remove(index)}
          >
            Remove
          </ReactBootstrap.Button>
        </ReactBootstrap.ListGroupItem>
      ))}
      <ReactBootstrap.ListGroupItem>
        <ReactBootstrap.Button
          style={{ float: 'right' }}
          variant="outline-dark"
          size="sm"
          onClick={() => fields.push({})}
        >
          {' '}
          Add{' '}
        </ReactBootstrap.Button>

        {submitFailed && error && <span>{error}</span>}
      </ReactBootstrap.ListGroupItem>
    </ReactBootstrap.ListGroup>
  )
}

let OptionsForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  editMode,
  dispatch,
}) => {
  const { list_types } = useSelector((state) => state.lists)
  useEffect(() => {
    !list_types && dispatch(getListTypes())
  }, [list_types, dispatch])

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Col xs="12">
        <Field
          component={renderers.renderSelectField}
          as="select"
          validate={[validations.required]}
          name="list_name"
          label="List Type"
        >
          {list_types &&
            list_types.map((list_type) => (
              <option key={list_type.key} value={list_type.key}>
                {list_type.display_text}
              </option>
            ))}
        </Field>
      </ReactBootstrap.Col>
      {editMode ? (
        <ReactBootstrap.Col xs="12">
          <Field
            name="value"
            type="text"
            validate={[validations.required]}
            component={renderers.renderField}
            label="Value"
          />
          <Field
            name="description"
            type="text"
            validate={[validations.required]}
            component={renderers.renderField}
            label="Description"
          />
          <Field
            name="code"
            type="text"
            validate={[validations.required]}
            component={renderers.renderField}
            label="Code"
          />
        </ReactBootstrap.Col>
      ) : (
        <ReactBootstrap.Col xs="12">
          <FieldArray name="items" component={renderListItems} />
        </ReactBootstrap.Col>
      )}
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}

OptionsForm = reduxForm({
  // a unique name for the form
  form: 'list-item-form',
})(OptionsForm)

export default OptionsForm
